var $390613981d970276$exports = {};
$390613981d970276$exports = {
  "Clear search": "T\xFChjenda otsing"
};
export { $390613981d970276$exports as default };